import { LoadingOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect } from "react";
import {AmplitudeEvent, logEvent} from "../utils/amplitude";

interface Props{
    disabled?: boolean;
    loading?: boolean;
    type: "cta" | "primary" | "secondary";
    children: any;
    onClick?: () => void,
    name: string,
    className?: string,
    keyboardKeys?: string[];
}

const Button = ({ disabled, type, onClick, children, loading= false, name, className, keyboardKeys }: Props) => {

    const classes = "relative px-[10px] w-full md:w-[210px] h-[54px] rounded-[3px] text-[20px] leading-6 font-semibold transition-colors hover:transition-colors ease-in-out duration-200 ";
    const ctaCls = "text-white bg-[#DC3545] border-none hover:bg-[#198754] disabled:bg-[#B6B6B6] disabled:border-none";
    const primaryCls = "text-white bg-[#198754] xl:bg-[#252429] border-none hover:bg-[#198754] disabled:bg-[#B6B6B6] disabled:border-none";
    const secondaryCls = "text-[#252429] bg-white border-solid border border-[#252429] hover:bg-[#6C757D] hover:text-white hover:border-none disabled:bg-[#B6B6B6] disabled:text-white disabled:border-none";

    const btnClassName = classes + (type === "cta" ? ctaCls : (type === "primary" ? primaryCls : secondaryCls)) + " " + className;

    const loadingIcon = loading && <LoadingOutlined className="absolute left-[10px]"/>;

    const onBtnClick = useCallback(() => {
        logEvent(AmplitudeEvent.BTN_CLICK, {btnName: name});

        if (onClick) onClick();
    }, [name, onClick]);

    useEffect(() => {
        const onKeyUp = (e: KeyboardEvent) => {
            if (keyboardKeys?.includes(e.key)) onBtnClick();
        };
        if (keyboardKeys?.length === 0 || !keyboardKeys) {
            return;
        } else {
            document.addEventListener('keyup', onKeyUp);
            return () => {
               document.removeEventListener('keyup', onKeyUp);
            }
        }

    }, [keyboardKeys, onBtnClick]);

    return (
        <button data-testid="btn-action" type="button" disabled={disabled || loading} onClick={onBtnClick} className={btnClassName} >
            {loadingIcon}
            {children}
        </button>
    )
};

export default Button;
